var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdjustIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15.75C0 16.9926 1.00736 18 2.25 18C3.22966 18 4.06309 17.3739 4.37197 16.5L17.25 16.5C17.6642 16.5 18 16.1642 18 15.75C18 15.3358 17.6642 15 17.25 15L4.37197 15C4.06309 14.1261 3.22966 13.5 2.25 13.5C1.00736 13.5 0 14.5074 0 15.75ZM2.25 16.5C1.83579 16.5 1.5 16.1642 1.5 15.75C1.5 15.3358 1.83579 15 2.25 15C2.66421 15 3 15.3358 3 15.75C3 16.1642 2.66421 16.5 2.25 16.5Z",
    fill: "#454A67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.628 12L0.75 12C0.335787 12 0 11.6642 0 11.25C0 10.8358 0.335787 10.5 0.75 10.5L10.628 10.5C10.9369 9.62611 11.7703 9 12.75 9C13.7297 9 14.5631 9.62611 14.872 10.5H17.25C17.6642 10.5 18 10.8358 18 11.25C18 11.6642 17.6642 12 17.25 12H14.872C14.5631 12.8739 13.7297 13.5 12.75 13.5C11.7703 13.5 10.9369 12.8739 10.628 12ZM12.75 12C12.3358 12 12 11.6642 12 11.25C12 10.8358 12.3358 10.5 12.75 10.5C13.1642 10.5 13.5 10.8358 13.5 11.25C13.5 11.6642 13.1642 12 12.75 12Z",
    fill: "#454A67"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.37803 7.5H0.75C0.335787 7.5 0 7.16421 0 6.75C0 6.33579 0.335787 6 0.75 6H2.37803C2.68691 5.12611 3.52034 4.5 4.5 4.5C5.47966 4.5 6.31309 5.12611 6.62197 6L17.25 6C17.6642 6 18 6.33578 18 6.75C18 7.16421 17.6642 7.5 17.25 7.5L6.62197 7.5C6.31309 8.37389 5.47966 9 4.5 9C3.52034 9 2.68691 8.37389 2.37803 7.5ZM4.5 7.5C4.08579 7.5 3.75 7.16421 3.75 6.75C3.75 6.33579 4.08579 6 4.5 6C4.91421 6 5.25 6.33579 5.25 6.75C5.25 7.16421 4.91421 7.5 4.5 7.5Z",
    fill: "#454A67"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.87803 3L0.75 3C0.335787 3 0 2.66421 0 2.25C0 1.83578 0.335787 1.5 0.75 1.5L6.87803 1.5C7.18691 0.626104 8.02034 0 9 0C9.97966 0 10.8131 0.626104 11.122 1.5H17.25C17.6642 1.5 18 1.83578 18 2.25C18 2.66421 17.6642 3 17.25 3L11.122 3C10.8131 3.87389 9.97966 4.5 9 4.5C8.02034 4.5 7.18691 3.87389 6.87803 3ZM9 3C8.58579 3 8.25 2.66421 8.25 2.25C8.25 1.83579 8.58579 1.5 9 1.5C9.41421 1.5 9.75 1.83579 9.75 2.25C9.75 2.66421 9.41421 3 9 3Z",
    fill: "#454A67"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdjustIcon);
export default __webpack_public_path__ + "static/media/adjustIcon.cbcf80bb4a8b624426303c057bc71653.svg";
export { ForwardRef as ReactComponent };